import React from "react";
import moment from "moment";
import { validateTime } from "../../utils";

import "react-day-picker/lib/style.css";
import "../../css/DateTextBox.css";

import { Input, Icon, Dropdown, Select } from "semantic-ui-react";
import { useIntl } from "react-intl";

interface TimeTextBoxProps {
 interval?: number;
 style?: Record<string,any>;
 value?: string;
 minHour?: number;
 maxHour?: number;
 onTimeChange?: () => void;
 defaultTime?: string;
 useDefaultTime?: boolean;
 clearable?: boolean;
 search?: boolean;
 confirmTime?: string;
}
class TimeTextBox extends React.Component<TimeTextBoxProps, any> {
  static defaultProps = {
    interval: 30,
    disabled: false,
    defaultTime: "00:00",
    minHour: 0,
    maxHour: 23,
    useDefaultTime: false,
    clearable: false,
    search: false,
    value: moment().format("HH:mm"),
    className: "",
    confirmTime: "",
  };

  validateTime: any;
  timerHandle: any;

  constructor(props: any) {
    super(props);
    this.state = {
      time: "",
      open: false,
      localOptions: [],
      minHour: props.minHour || 0,
      maxHour: props.maxHour || 23,
      typingTime: "",
    };
    // console.log("constructor this.state", this.state )
    this.validateTime = validateTime.bind(this);
  }

  componentDidMount() {
    // if (this.props.minHour) {
    //   this.setState({ minHour: this.props.minHour });
    // }
    // if (this.props.maxHour) {
    //   this.setState({ maxHour: this.props.maxHour });
    // }

    if (this.props.useDefaultTime) {
      if (this.validateTime(this.props.defaultTime)) {
        this.setState({ time: this.props.defaultTime });
        this.generateTimeShift(this.props.defaultTime);
      }
    } else if (this.props.value) {
      if (this.validateTime(this.props.value)) {
        this.timerHandle = setTimeout(() => {
          this.generateTimeShift(this.props.value);
          this.setState({ time: this.props.value });
          this.timerHandle = 0;
        }, 1);
      }
    }
  }

  componentWillUnmount() {
    if (this.timerHandle) {
      clearTimeout(this.timerHandle);
      this.timerHandle = 0;
    }
  }

  componentDidUpdate(prevProps: any, prevState: any) {
    // console.log('TimeTextBox componentDidUpdate  this.state: ', this.state );
    // console.log('TimeTextBox componentDidUpdate  this.props: ', this.props );
    // console.log('TimeTextBox componentDidUpdate this.state.time: ', this.state.time );
    // console.log('TimeTextBox componentDidUpdate this.validateTime(this.state.time): ', this.validateTime(this.state.time) );
    if (prevProps.availableOptions !== this.props.availableOptions) {
      if (this.validateTime(this.state.time)) {
        this.generateTimeShift(this.state.time);
      } else {
        // @ts-ignore
        this.generateTimeShift();
      }
    }

    if (this.props.interval && prevProps.interval !== this.props.interval) {
      if (this.validateTime(this.state.time)) {
        this.generateTimeShift(this.state.time);
      } else {
        // @ts-ignore
        this.generateTimeShift();
      }
    }

    if (!Number.isNaN(this.props.minHour)) {
      if (prevProps.minHour !== this.props.minHour) {
        this.setState({ minHour: this.props.minHour });
        if (this.validateTime(this.state.time)) {
          this.generateTimeShift(this.state.time);
        } else {
          // @ts-ignore
          this.generateTimeShift();
        }
      }
    }
    if (!Number.isNaN(this.props.maxHour)) {
      if (prevProps.maxHour !== this.props.maxHour) {
        this.setState({ maxHour: this.props.maxHour });
        if (this.validateTime(this.state.time)) {
          this.generateTimeShift(this.state.time);
        } else {
          // @ts-ignore
          this.generateTimeShift();
        }
      }
    }

    if (prevProps.value !== this.props.value) {
      if (this.validateTime(this.props.value)) {
        this.timerHandle = setTimeout(() => {
          this.setState({ time: this.props.value });
          this.generateTimeShift(this.props.value);
        }, 1);
      } else if (this.props.value === null) {
        this.setState({ time: "" });
      }
    }
  }

  generateTimeShift = (hourmin: any) => {
    // console.log("generateTimeShift hourmin: ", hourmin);
    var min = ":00";

    if (Array.isArray(this.props.availableOptions) && this.props.availableOptions?.length >= 0) {
      // CU Dent
      console.log(" CU Dent / DEFAULT = CU Dent ");
    } else {
      // Default
      console.log(" CU Dent / DEFAULT = DEFAULT ");
      if (hourmin) {
        min = hourmin.slice(-3);
      }
    }

    const formatTime = (decimalHour: number, defaultMin: string): string => {
      // ถ้าเป็นจำนวนเต็ม ใช้ min จาก parameter
      if (decimalHour % 1 === 0) {
        return `0${Math.floor(decimalHour)}`.slice(-2) + defaultMin;
      }
      // ถ้าเป็นทศนิยม แปลงเป็น HH:mm
      const hour = Math.floor(decimalHour);
      const minute = Math.round((decimalHour - hour) * 60);

      return `${`0${hour}`.slice(-2)}:${`0${minute}`.slice(-2)}`;
    };

    // console.log("generateTimeShift min: ", min);
    const date = moment().format("MM/DD/YYYY");
    // console.log("generateTimeShift date: ", date);

    let timeList: any[] = [];
    let start = moment(`${date} ${formatTime(this.props.minHour, min)}`, "MM/DD/YYYY HH:mm");

    // console.log("generateTimeShift start: ", start.toString());
    // console.log("generateTimeShift props.minHour", this.props.minHour)
    // console.log("generateTimeShift props.maxHour", this.props.maxHour)

    const end =
      Math.floor(this.props.maxHour) === 23
        ? moment(`${date} 23:59`, "MM/DD/YYYY HH:mm")
        : moment(`${date} ${formatTime(this.props.maxHour, min)}`, "MM/DD/YYYY HH:mm");
    console.log("generateTimeShift end: ", end.toString());

    if (Array.isArray(this.props.availableOptions) && this.props.availableOptions?.length >= 0) {
      // CU dent config
      // console.log("generateTimeShift CUDent !");
      // console.log('generateTimeShift start: ', start);
      // console.log('generateTimeShift end: ', end);

      while (start < end) {
        const time = moment(start).format("HH:mm");
        timeList.push({ text: time, value: time, key: time });
        if (this.props.interval <= 1) {
          start = moment(start).add(5, "minutes");
        } else {
          start = moment(start).add(this.props.interval, "minutes");
        }
      }
    } else {
      // original config
      // console.log("generateTimeShift Not CUDent !");
      while (start <= end) {
        const time = moment(start).format("HH:mm");
        timeList.push({ text: time, value: time, key: time });
        if (this.props.interval <= 1) {
          start = moment(start).add(5, "minutes");
        } else {
          start = moment(start).add(this.props.interval, "minutes");
        }
      }
    }

    // console.log(
    //   "generateTimeShift this.props.availableOptions",
    //   this.props.availableOptions
    // );
    // console.log('generateTimeShift timeList: ', timeList);

    /// availableOption fixed interval 5 mins
    if (Array.isArray(this.props.availableOptions) && this.props.availableOptions?.length >= 0) {
      const SLOT_LENGTH: number = 5;

      if (this.validateTime(hourmin) && !timeList.some((i) => i.text === hourmin)) {
        // console.log('B timeList: ', timeList);
        // console.log("B hourmin", hourmin)
        timeList = [{ key: hourmin, value: hourmin, text: hourmin }, ...timeList];
        timeList.sort((a, b) => {
          const [aHours, aMinutes] = a?.text?.split(":");
          const [bHours, bMinutes] = b?.text?.split(":");
          return moment()
            .hours(aHours)
            .minutes(aMinutes)
            .seconds(0)
            .milliseconds(0)
            .diff(moment().hours(bHours).minutes(bMinutes).seconds(0).milliseconds(0));
        });
      }
      // console.log('A timeList: ', timeList);

      timeList = timeList.map((list: any, idx: number) => {
        const availableOptions = this.props.availableOptions ?? [];

        let isTimeAvailable = false;

        for (const [index, option] of availableOptions.entries()) {
          const date = moment().format("YYYY-MM-DD");
          const nextTime = availableOptions[index + 1]?.value;
          // ช่วงเวลาของ available slot (5 นาที)
          const start = moment(`${date} ${option.value}`);
          const end = start.clone().add(SLOT_LENGTH, "minutes");
          const time = moment(`${date} ${list.value}`);
          const isAfterLastSlot = !nextTime && time.isAfter(end);

          // เช็คว่าเวลาอยู่ในช่วง available หรือหลัง slot สุดท้าย
          if (time.isBetween(start, end, null, "[]") || isAfterLastSlot) {
            isTimeAvailable = true;
            break;
          }
        }

        // ถ้าไม่พบใน available slots = ถูกจองแล้ว
        if (!isTimeAvailable && this.props.reservedText) {
          return { ...list, text: list.text + " " + this.props.reservedText };
        } else {
          return list;
        }
      });
    }
    // console.log("generateTimeShift timeList: ", timeList);

    this.setState({ localOptions: timeList });

    return timeList;
  };

  signalTimeChange = (e: any, value: any) => {
    const { onTimeChange } = this.props;

    this.setState({ time: value }, () => {
      if (onTimeChange) {
        this.props.onTimeChange(e, value);
      }
    });
  };

  openDropdown = () => {
    this.setState({ open: true });
  };

  handleTypingOnInputField = (e: any, data: any) => {
    console.log("data: ", data);
    // Store and close Modal

    this.setState({ typingTime: data.searchQuery });
    this.setState({ open: false });
  };

  handleOnBlur = (e: any) => {
    // After User Typing If valid then generate options list
    // Click dropdown looking on list and not selected any one

    if (this.state.typingTime) {
      this.setState({ open: false });
      if (!this.validateTime(this.state.typingTime)) {
        return this.signalTimeChange(e, "");
      }
      console.log(" valid time");

      setTimeout(() => {
        this.generateTimeShift(this.state.typingTime);
        this.setState({ time: "" });
        setTimeout(() => {
          let time = this.state.typingTime;
          this.setState({ time: time });
          this.signalTimeChange(e, time);
          this.setState({ typingTime: "" });
        }, 1);
      }, 1);
    } else {
      this.setState({ open: false });
    }
  };

  handleOnSelected = (e: any, data: any) => {
    this.setState({ typingTime: "" });
    this.setState({ open: false });
    this.signalTimeChange(e, data.value);
  };

  handleOnClose = (e: any, data: any) => {
    if (this.state.open) {
      this.setState({ open: false });
    }
  };

  handleOnOpen = () => {};

  render() {
    const { interval, style } = this.props;

    return (
      <Dropdown
        selection
        lazyLoad
        className={`icon ${this.props.className}`}
        open={this.state.open}
        style={{ ...style }}
        onClick={this.openDropdown}
        onSearchChange={this.handleTypingOnInputField}
        onBlur={this.handleOnBlur}
        options={this.state.localOptions}
        value={this.state.time}
        onChange={this.handleOnSelected}
        onClose={this.handleOnClose}
        onOpen={this.handleOnOpen}
        disabled={this.props.disabled}
        search={this.props.search}
        clearable={this.props.clearable}
        text={this.props.confirmTime}
      ></Dropdown>
    );
  }
}

export default TimeTextBox;
